module.exports = __webpack_public_path__ + "static/media/congrats-paper.8794d37b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/manage-redesign/congrats-paper.svg
// module id = 1466
// module chunks = 49